import { Component } from '@angular/core';
import { AppService } from '../../app.service';
import { catchError, finalize, firstValueFrom, switchMap, tap } from 'rxjs';
import { VmDropConfigService } from '../../services/vmdrop-config/vmdrop-config.service';
import { isArrayWithData } from '../../utilities/array.helpers';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
    selector: 'vmdrop-config',
    templateUrl: './vmdrop-config.component.html',
    styleUrl: './vmdrop-config.component.css',
})
export class VmDropConfigComponent {
    isSideBarVisible: boolean = false;
    isEditMode: boolean = false;
    isEditId: number = 0;
    selectedCreditorId: string = '';
    creditorCompanyName: string = '';
    vmDropConfigs!: any[];
    filteredVmDropConfigs: any[] = []; // filtered data
    filterVmDropStatus: boolean = true;
    vmDropForm!: FormGroup;
    isSubmitted = false;
    actionCreditorId: string = '';
    creditorHasFormData: boolean = false;
    filteredCreditors: any[] = [];
    vmDropEnabledCreditors: any[] = [];

    public constructor(
        public appService: AppService,
        private vmDropConfigService: VmDropConfigService,
        private fb: FormBuilder
    ) { }
    public vmDropStatusOptions = [
        {
            id: false,
            label: 'Inactive',
        },
        {
            id: true,
            label: 'Active',
        },
    ];
    public settlementTypeOptions = [
        {
            id: 1,
            label: 'Balance',
        },
        {
            id: 2,
            label: 'Duration',
        },
    ];

    ngOnInit() {
        this.initForm();
        this.getVmDropTableData(this.filterVmDropStatus);

    }

    get hasTableData(): boolean {
        return isArrayWithData(this.vmDropConfigs);
    }

    extractId(value: string | null | undefined): string {
        if (!value) return '';
        return value.split('/').pop() || '';
    }

    initForm() {
        this.vmDropForm = this.fb.group({
            BaseUrl: ['', Validators.required],
            BrandId: ['', Validators.required],
            TeamId: [''],
            SecretId: [''],
            VoiceMaleId: [''],
            VoiceFemaleId: [''],
            IsDisabled: [false],
            CreditorId: [0],
            PoolId: [''],
            CallerId: ['']
        });
    }

    getVmDropTableData(status: boolean) {
        const IsVMDropEnabled = status;
        this.appService.isShowPageSpinner = true;
        this.vmDropConfigs = [];
        this.vmDropConfigService.getVMDropConfigs(IsVMDropEnabled)
            .pipe(
                tap((res: any) => {
                    if (!!res) {
                        this.vmDropConfigs = res.result;
                        this.filteredVmDropConfigs = [...this.vmDropConfigs];
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
    }

    onSelectCreditor(event: any) {
        this.selectedCreditorId = event.CreditorId;
        this.creditorCompanyName = event.CompanyName;
        this.search()
    }

    search() {
        this.filteredVmDropConfigs = this.vmDropConfigs.filter(item => {
            const matchCreditor = !this.creditorCompanyName || item.CompanyName === this.creditorCompanyName;
            return matchCreditor;
        });
    }

    onOpenSideBar(data?: {creditorId?: string;}) {

        this.actionCreditorId = data?.creditorId || '';
        this.appService.isShowPageSpinner = true;
        this.vmDropConfigService.getVMDropIntegration(this.extractId(data?.creditorId))
            .pipe(
                switchMap(async (res: any) => {
                    if (res.Status) {
                        if(res.result){
                            this.isEditMode = true;
                            this.dataMappingForForm(res.result);
                            this.creditorHasFormData = true;
                        } else {
                            await this.getVMDropEnabledCreditors(true);
                            this.isEditMode = false;
                            this.vmDropForm.reset();
                            this.vmDropForm.patchValue({
                                CreditorId: this.extractId(data?.creditorId)
                            });
                            this.creditorHasFormData = false;
                        }
                        this.isSubmitted = false;
                        this.isSideBarVisible = true;
                    }
                    return res;
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
    }

    dataMappingForForm(data: any) {
        this.vmDropForm.patchValue({
            BaseUrl: data?.BaseUrl,
            BrandId: data?.BrandId,
            TeamId: data?.TeamId,
            SecretId: data?.SecretId,
            VoiceMaleId: data?.VoiceMaleId,
            VoiceFemaleId: data?.VoiceFemaleId,
            IsDisabled: data?.IsDisabled,
            CreditorId: data?.CreditorId,
            PoolId: data?.PoolId,
            CallerId: data?.CallerId
        });
        this.isEditId = data?.DropCowBoyIntegrationId;
    }

    onChangeStatus(creditorId: string, status: boolean) {
        const IsVMDropEnabled = status ? 1 : 0;
        this.appService.isShowPageSpinner = true;
        this.vmDropConfigService.updateVmDropStatus(creditorId, IsVMDropEnabled)
        .pipe(
            tap((res: any) => {
                if (res.Status) {
                    this.appService.showCommonMessageDialog(
                        'Success',
                        'VMDrop Config has been successfully updated.'
                    );
                    this.isSideBarVisible = false;
                    setTimeout(() => {
                        this.getVmDropTableData(this.filterVmDropStatus);
                    }, 100);
                }
            }),
            catchError(this.appService.handleError),
            finalize(() => {
                this.appService.isShowPageSpinner = false;
            })
        )
        .subscribe();
    } 
    
    onSave() {
        this.isSubmitted = true;
        if (this.vmDropForm.invalid) {
            this.vmDropForm.markAllAsTouched();
            return;
        }
         const payload = this.vmDropForm.value        
        
        if (this.isEditMode) { // call update API
            payload['DropCowBoyIntegrationId'] = this.isEditId;
           
            this.appService.isShowPageSpinner = true;
            this.vmDropConfigService.updateVmDropForm(payload)
            .pipe(
                tap((res: any) => {
                    if (res.Status) {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'VMDrop Config has been successfully updated.'
                        );
                        this.isSideBarVisible = false;
                        this.isSubmitted = false;
                        setTimeout(() => {
                            this.getVmDropTableData(this.filterVmDropStatus);
                        }, 100);
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
        } else {// call create API
            
            this.appService.isShowPageSpinner = true;
            this.vmDropConfigService.createVmDropForm(payload)
            .pipe(
                tap((res: any) => {
                    if (res.Status) {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'VMDrop Config has been successfully created.'
                        );
                        this.isSideBarVisible = false;
                        this.isSubmitted = false;
                        setTimeout(() => {
                            this.getVmDropTableData(this.filterVmDropStatus);
                        }, 100);
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
        }

    }

    async getVMDropEnabledCreditors(status: boolean) {
        const IsVMDropEnabled = status;
        try {
            const res: any = await firstValueFrom(this.vmDropConfigService.getVMDropConfigs(IsVMDropEnabled));
            if (res) {
                this.vmDropEnabledCreditors = res.result.map((item: any) => ({
                    CreditorId: item.CreditorId,
                    CompanyName: item.CompanyName
                }));
            }
        } catch (error) {
            this.appService.handleError;
        }
    }

    onSelectCreditorForForm(event: any) {
        const creditorId = this.extractId(event.value?.CreditorId);
        this.appService.isShowPageSpinner = true;
        this.vmDropConfigService.getVMDropIntegration(creditorId)
            .pipe(
                tap((res: any) => {
                    if (res.Status) {
                        this.dataMappingForForm(res.result);
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
    }

    filterCreditors(event: any) {
        let filteredItems: any[] = [];
        let query = event.query;

        for (let i = 0; i < (this.vmDropEnabledCreditors as any[]).length; i++) {
            let item = (this.vmDropEnabledCreditors as any[])[i];
            if (
                item.CreditorId.indexOf(query) !== -1 ||
                item.CompanyName.toLowerCase().indexOf(query.toLowerCase()) !==
                    -1
            ) {
                filteredItems.push(item);
            }
        }

        this.filteredCreditors = filteredItems;
    }
}
